import script from "./ProjectGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectGroup.vue?vue&type=script&setup=true&lang=js"

import "./ProjectGroup.vue?vue&type=style&index=0&id=7e656cd6&scoped=true&lang=scss"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e656cd6"]])

export default __exports__